/**
 * Breakpoints canônicos do projeto (em px) — fonte única de verdade no TS.
 * Mantenha em sincronia com src/app/shared/scss/_breakpoints.scss.
 *
 * "Mobile" para lógica de layout (sidebar/header/bottom-nav) é
 * largura <= MOBILE_BREAKPOINT.
 */
export const BREAKPOINT_SM = 576;
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 992;
export const BREAKPOINT_XL = 1200;

export const MOBILE_BREAKPOINT = BREAKPOINT_LG;
